/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ContactIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9932 12.2745L13.8857 13.7C14.0986 13.8596 14.2714 14.0667 14.3905 14.3047C14.5095 14.5428 14.5714 14.8053 14.5714 15.0714V15.9285L7.71429 15.9285V15.0714C7.71429 14.8053 7.77626 14.5428 7.89528 14.3047C8.0143 14.0667 8.1871 13.8596 8.40001 13.7L10.2926 12.2745"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
      />
      <path
        d="M12.8572 9.92852C12.8572 8.98175 12.0896 8.21423 11.1429 8.21423C10.1961 8.21423 9.42859 8.98175 9.42859 9.92852V10.7857C9.42859 11.7324 10.1961 12.4999 11.1429 12.4999C12.0896 12.4999 12.8572 11.7324 12.8572 10.7857V9.92852Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M3.42859 3.07141L17.1429 3.07141C17.5975 3.07141 18.0336 3.25202 18.3551 3.57351C18.6765 3.895 18.8572 4.33104 18.8572 4.7857L18.8572 20.2143C18.8572 20.6689 18.6765 21.105 18.3551 21.4265C18.0336 21.7479 17.5975 21.9286 17.1429 21.9286L3.42859 21.9286L3.42859 3.07141Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M21.4286 6.5V9.92857"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
